import { parseISO, format } from 'date-fns';
import { emailValidator } from 'libs/forms/validators';

// Based off https://stackoverflow.com/questions/4187146/truncate-number-to-two-decimal-places-without-rounding
function truncateToNDecimalPlaces(num: number, n: number) {
  const re = new RegExp(`^-?\\d+(?:\\.\\d{0,${n || -1}})?`);
  return Number(num.toString().match(re)?.[0]);
}

function truncateTo2DecimalPlaces(num: number) {
  return truncateToNDecimalPlaces(num, 2);
}

export const formatDate = (input: string | Date, formatter = 'do MMM yyyy') => {
  let dateInput = input;
  if (typeof input === 'string') {
    dateInput = parseISO(input) as Date;
  }
  return format(dateInput as Date, formatter);
};

export const formatCurrencySymbol = (currency: string) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).formatToParts(4242)[0].value;
};

export const formatCountryRegion = (region: string) => {
  return new Intl.DisplayNames(['en'], { type: 'region' }).of(region);
};

export const formatPrice = (price: number, currency: string) => {
  if (!Number.isNaN(price)) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency })
      .format(truncateTo2DecimalPlaces(price))
      .replace(/^(\D+)/, '$1 ')
      .replace(/\s+/, ' ');
  }

  return '--';
};

export const getUsernameByEmail = (email: string): string => {
  return emailValidator(email) ? email.split('@')[0] : '';
};

export const capitalizeWord = (word: string): string => {
  if (!word) return word;

  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const capitalizeFirstLetter = (
  text: string,
  separator = ' ',
): string => {
  if (!text) return text;

  return text
    .split(separator)
    .map(word => capitalizeWord(word))
    .join(separator);
};

export const formatAmount = (amount: number, currency = '€') => {
  const clampedAmount = Math.max(amount, 0);
  const amountString = !clampedAmount ? '0.00' : clampedAmount.toFixed(2);

  return `${currency}${amountString}`;
};

export const getBillingCycleByPlanName = (planName: string) => {
  const [, billingCycle] = planName.split(' ');
  return billingCycle;
};

export const renameRevisionToVersion = (s: string) =>
  s.replace('Revision', 'Version');
